"use client"
import { ArrowRightIcon, SignOutIcon } from "@phosphor-icons/react"
import { useClerk } from "@clerk/nextjs"
import { useRouter } from "next/navigation"
import type { ReactNode } from "react"
import type { AccessDeniedView } from "@/modules/authorization/access-denied"
import {
  StandaloneButton,
  StandaloneCard,
  StandaloneNote,
} from "@/components/kumo/standalone-card"
export function AccessDeniedClient({ view }: { view: AccessDeniedView }) {
  if (!view.account) {
    return (
      <AccessDeniedLayout>
        <StandaloneNote tone="info">{view.message}</StandaloneNote>
      </AccessDeniedLayout>
    )
  }
  return <AccessDeniedController view={view} account={view.account} />
}
function AccessDeniedController({
  view,
  account,
}: {
  view: AccessDeniedView
  account: NonNullable<AccessDeniedView["account"]>
}) {
  const clerk = useClerk()
  const router = useRouter()
  const openWorkspaceHref = view.openWorkspaceHref
  function useAnotherAccountOrSignIn() {
    if (account.action === "sign-out") {
      void clerk.signOut({ redirectUrl: "/login" })
      return
    }
    router.replace("/login")
  }
  return (
    <AccessDeniedLayout>
      <p className="text-kumo-subtle">{view.message}</p>

      {openWorkspaceHref ? (
        <StandaloneButton
          type="button"
          icon={ArrowRightIcon}
          onClick={() => router.replace(openWorkspaceHref)}
        >
          Open my Workspace
        </StandaloneButton>
      ) : null}

      <StandaloneButton
        type="button"
        variant={openWorkspaceHref ? "secondary" : "primary"}
        icon={account.action === "sign-out" ? SignOutIcon : ArrowRightIcon}
        onClick={useAnotherAccountOrSignIn}
      >
        {account.label}
      </StandaloneButton>
    </AccessDeniedLayout>
  )
}
function AccessDeniedLayout({ children }: { children: ReactNode }) {
  return (
    <StandaloneCard label="Access denied" title="Access is restricted">
      {children}
    </StandaloneCard>
  )
}
